var map = {
	"./b026/footer/footer": 596,
	"./b027site/footer/footer": 597,
	"./b027sport/footer/footer": 598,
	"./bet365luck/footer/footer": 599,
	"./betl/footer/footer": 600,
	"./common/footer/footer": 601,
	"./dafa/footer/footer": 602,
	"./taiyangcheng018/footer/footer": 603,
	"./yongligao/footer/footer": 604
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 658;


//////////////////
// WEBPACK FOOTER
// ./src/components/different ^\.\/.*\/footer\/footer$
// module id = 658
// module chunks = 31